import { Injectable } from '@angular/core';
import { GridApplicationTemplateRowData } from '../../../components/application-template-dashboard/models/grid-application-template-row-data';
import { GridApplicationTemplateRowResponse } from '../../../components/application-template-dashboard/models/grid-application-template-row-response';
import { formatToDate } from '../../../../../../core/functions/date-helpers';

@Injectable({
    providedIn: 'root',
})
export class ApplicationTemplateGridService {
    constructor() {}

    /**
     * Transforming the response data to the grid data for application templates.
     *
     * @param applicationTemplates the response data from the API.
     * @returns formatted application template data for the grid.
     */
    transformRowData(
        applicationTemplates: GridApplicationTemplateRowResponse[],
    ): GridApplicationTemplateRowData[] {
        return applicationTemplates.map((applicationTemplate) => ({
            templateApplicationMasterId:
                applicationTemplate.templateApplicationMasterId,
            name: applicationTemplate.name,
            description: applicationTemplate.description,
            createdAt: formatToDate(applicationTemplate.createdAt),
            updatedAt: formatToDate(applicationTemplate.updatedAt),
        }));
    }
}
